 <template>
    <gj-modal
        size="full-middle"
        v-bind="$attrs"
        v-on="$listeners"
        :visible.sync="modalVisible"
        @confirm="confirm"
        :class="{ 'goods-table': isGoods, 'enter-asin': !isGoods }">
        <template #header>{{ title }}</template>
        <template #content>
            <template v-if="isGoods">
                <div class="flex">
                    <gj-country-server-select
                        v-model="countryMarket"
                        :width="['130px', '160px']">
                    </gj-country-server-select>
                    <gj-select-input
                        v-model="keyword"
                        :options="[
                            {id: 'asinList', text: 'ASIN',  moreShow: true },
                            {id: 'sku', text: 'SKU'},
                        ]"
                        style="margin-left: 10px;"
                        :singe-input="true"
                        :width="['100px', '150px']">
                    </gj-select-input>
                    <gj-button size="small" class="gj-ml10" @click="query">查询</gj-button>
                </div>
                <gj-table
                    :data="tableData"
                    :columns="columns"
                    :index="false"
                    :height="370"
                    selection
                    :adapt-height="false"
                    :loading="loading"
                    style="margin-top:20px"
                    @checkbox-all="selectionChange"
                    @checkbox-change="selectionChange"
                    @sort-change="sortChange"
                    :default-sort="{ order: '', prop: ''}">
                    <template v-slot:imageUrl="{ row }">
                        <img :src="row.imageUrl" alt="" width="30px">
                    </template>
                    <template v-slot:status="{ row }">
                        <gj-tag type="text" :color="getColor(row.status)">{{ row.status | optionText(listingStatustwo) }}</gj-tag>
                    </template>
                </gj-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
            <template v-else>
                <gj-input v-model="asinValue" type="textarea" class="enter-asin-input" placeholder="一行一项，最多支持200个">
                </gj-input>
                <div style="margin-top:10px;"><i class="el-icon-warning"></i> 系统会自动过滤掉非选择店铺站点、错误、无权限、非本客户的商品数据</div>
            </template>
        </template>
    </gj-modal>
</template>

<script>
import { simpleListings } from "../../../../../api/crm";
import {ProductEnum, listingStatus, listingStatustwo} from "@/utils/options";
import { modalMixIn } from "./../../../../../minxins";
import { tagColors } from '@/components/tag/tag-colors';
import { mapGetters } from 'vuex';
export default {
    name: "send-rule-goods-table",
    mixins: [modalMixIn],
    props: {
        title: String,
        hideIds: {
            type: Array,
            default: () => []
        },
        countryMarketValue: {
            type: Object,
            default: () => null
        },
        isGoods: Boolean
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption',
      }),
    },
    data() {
        return {
            tableData: [],
            pagination: {},
            countryMarket: null,
            keyword: {
                key: 'asinList',
                value: null
            },
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            // asinList: '',
            asinValue: '',
            moreArr: [],
            columns: [
                { id: 'imageUrl', header: '图片', field: 'slot:imageUrl', minWidth: '100px' },
                { id: 'asin', header: 'ASIN', field: 'asin', minWidth: '150px' },
                { id: 'sku', header: 'SKU', field: 'sku', minWidth: '100px', sortable: true },
                { id: 'marketId', header: '店铺/站点', field: 'option:marketId', minWidth: '100px', options: () => this.marketOption, },
                { id: 'status', header: '状态', field: 'slot:status', minWidth: '100px' },
            ],
            selectionData: [],
            listingStatus,
            listingStatustwo,
            sort: {
                order: '',
                prop: ''
            },
        }
    },
    created() {
        this.countryMarket = this.countryMarketValue
        if (this.isGoods) this.query()
    },
    methods: {
        query() {
            this.loading = true;
            let model = {
                excludeListingIds: this.hideIds,
                countryCodes: this.countryMarket.countryIds || [],
                marketIds: this.countryMarket.marketIds || []
            }
            if (this.isGoods) {
                model[this.keyword.key] = this.keyword.value;
                if(['asinList'].includes(this.keyword.key)){
                    if(this.keyword.value){
                        model[this.keyword.key] = this.keyword.value.split(',');
                    }else{
                        model[this.keyword.key] = [];
                    }
                }
            } else {
                model.asinList = this.moreArr
            }
            simpleListings({
                size: this.pageSize,
                current: this.isGoods ? this.currentPage : 1,
                model: model,
                order: this.sort.order,
                sort: this.sort.prop
            }).then(res => {
                this.total = res.total;
                this.tableData = res.records;
                if (!this.isGoods) {
                    this.$emit('confirmSelect', this.tableData);
                    this.$gjDestroy();
                }
            }).complete(() => {
                this.loading = false;
            });
        },
        getColor(status) {
            switch (status) {
            case 'Active':
                return tagColors.greenText;
            case 'Inactive':
                return tagColors.gray9Text;
            case 'Incomplete':
                return tagColors.orangeText;
            case 'Delete':
                return tagColors.gray6Text;
            }
        },
        sortChange({column, property, order}) {
            if (order) {
                this.sort.prop = (column.sortBy || property || '').replace(/(slot:)|(option(\(.*\))?:)/, '');
                this.sort.order = `${order}ending`;
            } else {
                this.sort.prop = null;
                this.sort.order = null;
            }
            this.currentPage = 1
            this.query();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.query();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.query();
        },
        selectionChange(obj) {
            this.selectionData = obj.records;
        },
        confirm() {
            if (this.isGoods) {
                if (this.selectionData.length == 0) {
                    this.$gjMessage.warning('请先选择商品！');
                    return false;
                }
                this.$emit('confirmSelect', this.selectionData);
                this.$gjDestroy();
            } else {
                this.moreArr = this.asinValue.split('\n').filter(item => item != "");
                this.query();
            }
        }
    },
}
</script>

<style lang="scss">
.goods-table {
    .tool-group-mail {
        display: flex;
        width: auto;
        margin-right: 15px;

        img {
            cursor: pointer;
            margin: 2px 10px;
            width: 15px;
            height: 15px;
        }
    }

    div.el-dialog {
        height: 600px !important
    }

    .input-with-select {
        width: 220px;
        margin-right: 15px;

        .el-input-group__prepend {
            width: 40px;
            background: #fff;

            .el-select.el-select--small {
                margin: -6px -20px;
            }
        }
    }

    .el-pagination {
        text-align: end;
        margin-top: 15px;
    }

    .el-dialog__footer {
        padding-top: 0 !important;
    }
}

.enter-asin {
    div.el-dialog {
        height: 320px !important;
        width: 600px !important;

        .el-dialog__body {
            padding-bottom: 0;

            .enter-asin-input {
                width: 560px !important;

                .el-textarea__inner {
                    height: 169px;
                }
            }

            .el-icon-warning {
                color: #ED6A0C;
                font-size: 16px;
            }
        }
    }
}
</style>
